"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getValueWithOverrides = getValueWithOverrides;
var _createUrlEnvKey = require("./createUrlEnvKey");
function getValueWithOverrides(serviceName, urlName, url) {
  return typeof window === 'undefined' ? process.env[(0, _createUrlEnvKey.createUrlEnvKey)(serviceName, urlName)] ?? url : url;
}
